import { createTheme } from '@mui/material';
import { commonThemeConfig, portalThemeConfig, RADIUS } from './config';

export const commonTheme = createTheme(commonThemeConfig);
export const portalTheme = createTheme(portalThemeConfig);

export const CARD_BOX_SHADOW = '0px 4px 20px rgba(0, 0, 0, 0.1)';
export const PRIMARY_COLOR_HOVER = '#005331';
export const PRIMARY_COLOR_LIGHT = '#DBFFF1';

export { RADIUS };
